export enum ActionTypes {
	// BENCHMARKS
	BENCHMARKS_GET_REQUESTED = 'BENCHMARKS_GET_REQUESTED',
	BENCHMARKS_GET_FAILED = 'BENCHMARKS_GET_FAILED',
	BENCHMARKS_GET_SUCCESSFUL = 'BENCHMARKS_GET_SUCCESSFUL',
	BENCHMARKS_SELECTION_UPDATE = 'BENCHMARKS_SELECTION_UPDATE',
	BENCHMARKS_SELECTION_ADD = 'BENCHMARKS_SELECTION_ADD',
	BENCHMARKS_SELECTION_REMOVE = 'BENCHMARKS_SELECTION_REMOVE',
	BENCHMARKS_GET_MISSING_SUCCESSFUL = 'BENCHMARKS_GET_MISSING_SUCCESSFUL',
	BENCHMARK_GET_GLOBALTOPQUARTILEID = 'BENCHMARK_GET_GLOBALTOPQUARTILEID',

	// CULTURES
	CULTURES_GET_FAILED = 'CULTURES_GET_FAILED',
	CULTURES_GET_REQUESTED = 'CULTURES_GET_REQUESTED',
	CULTURES_GET_SUCCESSFUL = 'CULTURES_GET_SUCCESSFUL',
	CULTURES_SELECTION_UPDATE = 'CULTURES_SELECTION_UPDATE',
	CULTURES_DEFAULT_CULTURE_UPDATE = 'CULTURES_DEFAULT_CULTURE_UPDATE',

	// TEXT TO SPEECH CULTURES
	TEXTTOSPEECH_SUPPORTEDCULTURES_GET_FAILED = 'TEXTTOSPEECH_SUPPORTEDCULTURES_GET_FAILED',
	TEXTTOSPEECH_SUPPORTEDCULTURES_GET_REQUESTED = 'TEXTTOSPEECH_SUPPORTEDCULTURES_GET_REQUESTED',
	TEXTTOSPEECH_SUPPORTEDCULTURES_GET_SUCCESSFUL = 'TEXTTOSPEECH_SUPPORTEDCULTURES_GET_SUCCESSFUL',

	// CUSTOM QUESTIONS
	CUSTOM_QUESTIONS_GET_FAILED = 'CUSTOM_QUESTIONS_GET_FAILED',
	CUSTOM_QUESTIONS_GET_REQUESTED = 'CUSTOM_QUESTIONS_GET_REQUESTED',
	CUSTOM_QUESTIONS_GET_SUCCEEDED = 'CUSTOM_QUESTIONS_GET_SUCCEEDED',
	CUSTOM_QUESTIONS_UPDATE_SELECTED = 'CUSTOM_QUESTIONS_UPDATE_SELECTED',

	// CUSTOM QUESTION
	CUSTOM_QUESTION_RESET = 'CUSTOM_QUESTION_RESET',
	CUSTOM_QUESTION_GET_FAILED = 'CUSTOM_QUESTION_GET_FAILED',
	CUSTOM_QUESTION_GET_REQUESTED = 'CUSTOM_QUESTION_GET_REQUESTED',
	CUSTOM_QUESTION_GET_SUCCEEDED = 'CUSTOM_QUESTION_GET_SUCCEEDED',
	CUSTOM_QUESTION_SAVE_FAILED = 'CUSTOM_QUESTION_SAVE_FAILED',
	CUSTOM_QUESTION_SAVE_REQUESTED = 'CUSTOM_QUESTION_SAVE_REQUESTED',
	CUSTOM_QUESTION_SAVE_SUCCEEDED = 'CUSTOM_QUESTION_SAVE_SUCCEEDED',
	CUSTOM_QUESTION_VALIDATION_FAILED = 'CUSTOM_QUESTION_VALIDATION_FAILED',
	CUSTOM_QUESTION_HANDLE_ROG_CHANGE = 'CUSTOM_QUESTION_HANDLE_ROG_CHANGE',
	CUSTOM_QUESTION_HANDLE_TRANSLATION_CHANGE = 'CUSTOM_QUESTION_HANDLE_TRANSLATION_CHANGE',
	CUSTOM_QUESTION_HANDLE_TEXT_CHANGE = 'CUSTOM_QUESTION_HANDLE_TEXT_CHANGE',
	CUSTOM_QUESTION_HANDLE_QUESTION_TYPE_CHANGE = 'CUSTOM_QUESTION_HANDLE_QUESTION_TYPE_CHANGE',
	CUSTOM_QUESTION_HANDLE_ATTRIBUTE_NAME_CHANGE = 'CUSTOM_QUESTION_HANDLE_ATTRIBUTE_NAME_CHANGE',
	CUSTOM_QUESTION_GET_RESPONSEOPTIONGROUPS_FAILED = 'CUSTOM_QUESTION_GET_RESPONSEOPTIONGROUPS_FAILED',
	CUSTOM_QUESTION_GET_RESPONSEOPTIONGROUPS_REQUESTED = 'CUSTOM_QUESTION_GET_RESPONSEOPTIONGROUPS_REQUESTED',
	CUSTOM_QUESTION_GET_RESPONSEOPTIONGROUPS_SUCCEEDED = 'CUSTOM_QUESTION_GET_RESPONSEOPTIONGROUPS_SUCCEEDED',
	CUSTOM_QUESTION_SELECTED = 'CUSTOM_QUESTION_SELECTED',
	CUSTOM_QUESTION_RESPONSEOPTION_UPDATE_TEXT = 'CUSTOM_QUESTION_RESPONSEOPTION_UPDATE_TEXT',
	CUSTOM_QUESTION_RESPONSEOPTION_UPDATE_GROUP_NAME = 'CUSTOM_QUESTION_RESPONSEOPTION_UPDATE_GROUP_NAME',
	CUSTOM_QUESTION_RESPONSEOPTION_MULTIPLE_TOGGLE = 'CUSTOM_QUESTION_RESPONSEOPTION_MULTIPLE_TOGGLE',
	CUSTOM_QUESTION_RESPONSEOPTION_UPDATE_VALUE = 'CUSTOM_QUESTION_RESPONSEOPTION_UPDATE_VALUE',
	CUSTOM_QUESTION_RESPONSEOPTION_SORT = 'CUSTOM_QUESTION_RESPONSEOPTION_SORT',
	CUSTOM_QUESTION_SET_OPENENDED = 'CUSTOM_QUESTION_SET_OPENENDED',
	CUSTOM_QUESTION_SET_TEXTBOX = 'CUSTOM_QUESTION_SET_TEXTBOX',
	CUSTOM_QUESTION_RESPONSEOPTION_ADD = 'CUSTOM_QUESTION_RESPONSEOPTION_ADD',
	CUSTOM_QUESTION_RESPONSEOPTION_DELETE = 'CUSTOM_QUESTION_RESPONSEOPTION_DELETE',
	CUSTOM_QUESTION_HANDLE_FOLLOW_UP_CHECK = 'CUSTOM_QUESTION_HANDLE_FOLLOW_UP_CHECK',
	CUSTOM_QUESTION_HANDLE_HIERARCHY_CHANGE = 'CUSTOM_QUESTION_HANDLE_HIERARCHY_CHANGE',
	CUSTOM_QUESTION_RESPONSE_OPTIONS_GROUP_TAB_CHANGE = 'CUSTOM_QUESTION_RESPONSE_OPTIONS_GROUP_TAB_CHANGE',
	CUSTOM_QUESTION_RESPONSE_OPTIONS_RANKING_TOGGLE = 'CUSTOM_QUESTION_RESPONSE_OPTIONS_RANKING_TOGGLE',

	// SURVEY
	SURVEY_SET_DEFAULT_STATE = 'SURVEY_SET_DEFAULT_STATE',
	SURVEY_GET_REQUESTED = 'SURVEY_GET_REQUESTED',
	SURVEY_QUESTION_DISPLAY_RULES_COUNT_UPDATE = 'SURVEY_QUESTION_DISPLAY_RULES_COUNT_UPDATE',
	SURVEY_QUESTION_SYNC_WITH_QUESTIONLIBRARY = 'SURVEY_QUESTION_SYNC_WITH_QUESTIONLIBRARY',
	SURVEY_QUESTIONS_SYNC_WITH_QUESTIONLIBRARY = 'SURVEY_QUESTIONS_SYNC_WITH_QUESTIONLIBRARY',
	SURVEY_GET_SUCCEEDED = 'SURVEY_GET_SUCCEEDED',
	SURVEY_GET_FAILED = 'SURVEY_GET_FAILED',
	SURVEY_PREVIEW_GET_REQUESTED = 'SURVEY_PREVIEW_GET_REQUESTED',
	SURVEY_PREVIEW_GET_SUCCEEDED = 'SURVEY_PREVIEW_GET_SUCCEEDED',
	SURVEY_PREVIEW_COMPLETED = 'SURVEY_PREVIEW_COMPLETED',
	SURVEY_NAME_UPDATE = 'SURVEY_NAME_UPDATE',
	SURVEY_TEXTTOSPEECH_UPDATE = 'SURVEY_TEXTTOSPEECH_UPDATE',
	SURVEY_SET_AUDIENCE_SOURCE_TYPE = 'SURVEY_SET_AUDIENCE_SOURCE_TYPE',
	SURVEY_SET_EXTERNAL_APPLICATION_TYPE = 'SURVEY_SET_EXTERNAL_APPLICATION_TYPE',
	SURVEY_SET_SURVEY_TYPE = 'SURVEY_SET_SURVEY_TYPE',
	SURVEY_SET_EXTERNAL_SOURCE = 'SURVEY_SET_EXTERNAL_SOURCE',
	SURVEY_TITLE_UPDATED = 'SURVEY_TITLE_UPDATED',
	SURVEY_TITLE_CHANGE = 'SURVEY_TITLE_CHANGE',
	SURVEY_PUBLISH_DESTINATION_CHANGE = 'SURVEY_PUBLISH_DESTINATION_CHANGE',
	SURVEY_INTRO_UPDATED = 'SURVEY_INTRO_UPDATED',
	SURVEY_INTRO_CHANGE = 'SURVEY_INTO_CHANGE',
	SURVEY_CONTENT_ITEM_SORT = 'SURVEY_CONTENT_ITEM_SORT',
	SURVEY_INSTRUCTIONS_UPDATED = 'SURVEY_INSTRUCTIONS_UPDATED',
	SURVEY_INSTRUCTIONS_CHANGE = 'SURVEY_INSTRUCTIONS_CHANGE',
	SURVEY_PRIVACYPOLICY_SWITCH_UPDATE = 'SURVEY_PRIVACYPOLICY_SWITCH_UPDATE',
	SURVEY_PRIVACYPOLICY_COPY_UPDATE = 'SURVEY_PRIVACYPOLICY_COPY_UPDATE',
	SURVEY_PRIVACYPOLICY_USECLIENT_UPDATE = 'SURVEY_PRIVACYPOLICY_USECLIENT_UPDATE',
	SURVEY_PRIVACYPOLICY_TITLE_CHANGE = 'SURVEY_PRIVACYPOLICY_TITLE_CHANGE',
	SURVEY_PRIVACYPOLICY_CONTENT_CHANGE = 'SURVEY_PRIVACYPOLICY_CONTENT_CHANGE',
	SURVEY_PRIVACYPOLICY_CHECKBOX_CHANGE = 'SURVEY_PRIVACYPOLICY_CHECKBOX_CHANGE',
	SURVEY_PRIVACYPOLICY_TITLE_TRANSLATION_UPDATE = 'SURVEY_PRIVACYPOLICY_TITLE_TRANSLATION_UPDATE',
	SURVEY_PRIVACYPOLICY_CLEAR_UPDATE = 'SURVEY_PRIVACYPOLICY_CLEAR_UPDATE',
	SURVEY_PRIVACYPOLICY_CONTENT_TRANSLATION_UPDATE = 'SURVEY_PRIVACYPOLICY_CONTENT_TRANSLATION_UPDATE',
	SURVEY_PRIVACYPOLICY_CHECKBOX_TRANSLATION_UPDATE = 'SURVEY_PRIVACYPOLICY_CHECKBOX_TRANSLATION_UPDATE',
	SURVEY_PRIVACYPOLICY_ADMIN_SAVED = 'SURVEY_PRIVACYPOLICY_ADMIN_SAVED',
	SURVEY_PRIVACYPOLICY_TRANSLATION_UPDATED = 'SURVEY_PRIVACYPOLICY_TRANSLATION_UPDATED',
	SURVEY_DEFINITIONS_SWITCH_UPDATE = 'SURVEY_DEFINITIONS_SWITCH_UPDATE',
	SURVEY_DEFINITIONS_INITIALIZE_REQUESTED = 'SURVEY_DEFINITIONS_INITIALIZE_REQUESTED',
	SURVEY_DEFINITIONS_INITIALIZE_FAILED = 'SURVEY_DEFINITIONS_INITIALIZE_FAILED',
	SURVEY_TERM_PAGE_DESCRIPTION_CHANGE = 'SURVEY_TERM_PAGE_DESCRIPTION_CHANGE',
	SURVEY_TERM_PAGE_DESCRIPTION_UPDATE = 'SURVEY_TERM_PAGE_DESCRIPTION_UPDATE',
	SURVEY_TERM_ITEM_CHANGE = 'SURVEY_TERM_ITEM_CHANGE',
	SURVEY_TERM_ITEM_ADD = 'SURVEY_TERM_ITEM_ADD',
	SURVEY_TERM_ITEM_DELETE = 'SURVEY_TERM_ITEM_DELETE',
	SURVEY_TERM_ITEMS_FETCH = 'SURVEY_TERM_ITEMS_FETCH',
	SURVEY_TERM_ADMIN_LOADING = 'SURVEY_TERM_ADMIN_LOADING',
	SURVEY_TERM_ADMIN_SAVED = 'SURVEY_TERM_ADMIN_SAVED',
	SURVEY_TERM_TRANSLATION_UPDATED = 'SURVEY_TERM_TRANSLATION_UPDATED',
	SURVEY_ADDKINCENTRICPRIVACYPOLICY_REQUESTED = 'SURVEY_ADDKINCENTRICPRIVACYPOLICY_REQUESTED',
	SURVEY_ADDKINCENTRICPRIVACYPOLICY_SUCCEEDED = 'SURVEY_ADDKINCENTRICPRIVACYPOLICY_SUCCEEDED',
	SURVEY_ADDKINCENTRICPRIVACYPOLICY_FAILED = 'SURVEY_ADDKINCENTRICPRIVACYPOLICY_FAILED',
	SURVEY_TEXTTOSPEECH_INSTRUCTIONS_UPDATED = 'SURVEY_TEXTTOSPEECH_INSTRUCTIONS_UPDATED',
	SURVEY_TEXTTOSPEECH_INSTRUCTIONS_CHANGE = 'SURVEY_TEXTTOSPEECH_INSTRUCTIONS_CHANGE',
	SURVEY_PUBLISH_FAILED = 'SURVEY_PUBLISH_FAILED',
	SURVEY_PUBLISH_REQUESTED = 'SURVEY_PUBLISH_REQUESTED',
	SURVEY_PUBLISH_SUCCEEDED = 'SURVEY_PUBLISH_SUCCEEDED',
	SURVEY_PUBLISH_PREVIEW_SUCCEEDED = 'SURVEY_PUBLISH_PREVIEW_SUCCEEDED',
	SURVEY_SAVE_FAILED = 'SURVEY_SAVE_FAILED',
	SURVEY_SAVE_SUCCEEDED = 'SURVEY_SAVE_SUCCEEDED',
	SURVEYQUESTION_DELETE = 'SURVEYQUESTION_DELETE',
	FOLLOWUPQUESTION_RESPONSELIMIT_UPDATE = 'FOLLOWUPQUESTIONOPTIONMAX_UPDATE',
	FOLLOWUPQUESTION_RESPONSEOPTIONS_UPDATE = 'FOLLOWUPQUESTIONOPTIONS_UPDATE',
	UPDATE_QUESTION_TYPE = 'UPDATE_QUESTION_TYPE',
	UPDATE_QUESTION_REQUIRED = 'UPDATE_QUESTION_REQUIRED',
	TOGGLE_WARNING_MODAL = 'TOGGLE_WARNING_MODAL',
	SURVEYQUESTION_LIST_SORT = 'SURVEYQUESTION_LIST_SORT',
	QUESTION_IS_REQUIRED_TOGGLE = 'QUESTION_IS_REQUIRED_TOGGLE',
	HIDE_QUESTION_TOGGLE = 'HIDE_QUESTION_TOGGLE',
	SURVEY_CANCEL_FAILED = 'SURVEY_CANCEL_FAILED',
	SURVEY_CANCEL_REQUESTED = 'SURVEY_CANCEL_REQUESTED',
	SURVEY_CANCEL_SUCCEEDED = 'SURVEY_CANCEL_SUCCEEDED',
	EXTERNAL_APPLICATION_TYPES_GET_REQUESTED = 'EXTERNAL_APPLICATION_TYPES_GET_REQUESTED',
	EXTERNAL_APPLICATION_TYPES_GET_SUCCEEDED = 'EXTERNAL_APPLICATION_TYPES_GET_SUCCEEDED',
	EXTERNAL_APPLICATION_TYPES_GET_FAILED = 'EXTERNAL_APPLICATION_TYPES_GET_FAILED',
	SURVEY_URLS_DOWNLOAD_FAILED = 'SURVEY_URLS_DOWNLOAD_FAILED',
	SURVEY_URLS_DOWNLOAD_REQUESTED = 'SURVEY_URLS_DOWNLOAD_REQUESTED',
	SURVEY_URLS_DOWNLOAD_SUCCEEDED = 'SURVEY_URLS_DOWNLOAD_SUCCEEDED',
	SURVEY_PROGRESS_METER_TYPE_CHANGE = 'SURVEY_PROGRESS_METER_TYPE_CHANGE',
	SET_RANDOMIZE_ON_QUESTIONS_IN_SEQUENCE = 'SET_RANDOMIZE_ON_QUESTIONS_IN_SEQUENCE',
	SHOW_QUESTION_NUMBERING = 'SHOW_QUESTION_NUMBERING',
	SHOW_KINCENTRIC_LOGO_CHANGE = 'SHOW_KINCENTRIC_LOGO_CHANGE',

	// SURVEY NOTES
	SURVEY_NOTES_GET_REQUESTED = 'SURVEY_NOTES_GET_REQUESTED',
	SURVEY_NOTES_GET_SUCCEEDED = 'SURVEY_NOTES_GET_SUCCEEDED',
	SURVEY_NOTE_SAVE_REQUESTED = 'SURVEY_NOTE_SAVE_REQUESTED',
	SURVEY_NOTE_SAVE_SUCCEEDED = 'SURVEY_NOTE_SAVE_SUCCEEDED',
	SURVEY_NOTE_DELETE_REQUESTED = 'SURVEY_NOTE_DELETE_REQUESTED',
	SURVEY_NOTE_DELETE_SUCCEEDED = 'SURVEY_NOTE_DELETE_SUCCEEDED',

	// SURVEY LIST
	SURVEY_LIST_CLEAR_VALIDATION = 'SURVEY_LIST_CLEAR_VALIDATION',
	SURVEY_LIST_CLONE_SURVEY_FAILED = 'SURVEY_LIST_CLONE_SURVEY_FAILED',
	SURVEY_LIST_CLONE_SURVEY_SUCCEEDED = 'SURVEY_LIST_CLONE_SUCCEEDED',
	SURVEY_LIST_CLONE_SURVEY_REQUESTED = 'SURVEY_LIST_CLONE_SURVEY_REQUESTED',
	SURVEY_LIST_COLUMNS_GET_SUCCEEDED = 'SURVEY_LIST_COLUMNS_GET_SUCCEEDED',
	SURVEY_LIST_COLUMNS_GET_REQUESTED = 'SURVEY_LIST_COLUMNS_GET_REQUESTED',
	SURVEY_LIST_COLUMNS_UPDATE = 'SURVEY_LIST_COLUMNS_UPDATE',
	SURVEY_LIST_DELETE_SURVEY_FAILED = 'SURVEY_LIST_DELETE_SURVEY_FAILED',
	SURVEY_LIST_DELETE_SURVEY_REQUESTED = 'SURVEY_LIST_DELETE_SURVEY_REQUESTED',
	SURVEY_LIST_DELETE_SURVEY_SUCCEEDED = 'SURVEY_LIST_DELETE_SURVEY_SUCCEEDED',
	SURVEY_LIST_GET_FAILED = 'SURVEY_LIST_GET_FAILED',
	SURVEY_LIST_GET_REQUESTED = 'SURVEY_LIST_GET_REQUESTED',
	SURVEY_LIST_GET_SUCCEEDED = 'SURVEY_LIST_GET_SUCCEEDED',
	SURVEY_LIST_UPDATE_SURVEY_NAME = 'SURVEY_LIST_UPDATE_SURVEY_NAME',

	// QUESTION MODAL
	SURVEYQUESTIONS_MODAL_OPEN = 'SURVEYQUESTIONS_MODAL_OPEN',
	SURVEYQUESTIONS_MODAL_SUBMIT = 'SURVEYQUESTIONS_MODAL_SUBMIT',
	SURVEYQUESTIONS_MODAL_CLOSE = 'SURVEYQUESTIONS_MODAL_CLOSE',
	CUSTOMQUESTIONS_MODAL_OPEN = 'CUSTOMQUESTIONS_MODAL_OPEN',
	CUSTOMQUESTIONS_MODAL_ADD_OR_EDIT_QUESTION = 'CUSTOMQUESTIONS_MODAL_ADD_OR_EDIT_QUESTION',
	CUSTOMQUESTIONS_MODAL_CANCEL_ADD_OR_EDIT_QUESTION = 'CUSTOMQUESTIONS_MODAL_CANCEL_ADD_OR_EDIT_QUESTION',
	CUSTOMQUESTIONS_MODAL_TOGGLE_WARNING_MODAL = 'CUSTOMQUESTIONS_MODAL_TOGGLE_WARNING_MODAL ',
	DEMOGRAPHICQUESTIONS_MODAL_OPEN = 'DEMOGRAPHICQUESTIONS_MODAL_OPEN',
	CUSTOMDDEMOGRAPHICQUESTIONS_MODAL_OPEN = 'CUSTOMDDEMOGRAPHICQUESTIONS_MODAL_OPEN',
	PAGEFLOW_ELEMENT_MODAL_SUBMIT = 'PAGEFLOW_ELEMENT_MODAL_SUBMIT',
	SURVEYELEMENT_DELETE = 'SURVEYELEMENT_DELETE',

	// LIBRARY QUESTION LIST
	LIBRARY_QUESTIONS_GET_REQUESTED = 'LIBRARY_QUESTIONS_GET_REQUESTED',
	LIBRARY_QUESTIONS_GET_SUCCEEDED = 'LIBRARY_QUESTIONS_GET_SUCCEEDED',
	LIBRARY_QUESTIONS_GET_FAILED = 'LIBRARY_QUESTIONS_GET_FAILED',
	LIBRARY_QUESTION_SHOW_ALL_VARIATIONS = 'LIBRARY_QUESTION_SHOW_ALL_VARIATIONS',
	LIBRARY_QUESTION_SHOW_SINGLE_VARIATION = 'LIBRARY_QUESTION_SHOW_SINGLE_VARIATION',
	LIBRARY_QUESTION_UPDATE_COLUMNS = 'LIBRARY_QUESTION_UPDATE_COLUMNS',
	LIBRARY_QUESTION_SELECTED = 'LIBRARY_QUESTION_SELECTED',
	LIBRARY_QUESTIONVARIATION_SELECTED = 'LIBRARY_QUESTIONVARIATION_SELECTED',
	LIBRARY_QUESTION_SELECT_DIMENSION = 'LIBRARY_QUESTION_SELECT_DIMENSION',

	// TRANSLATIONS
	TRANSLATION_EDITOR_UPDATED = 'TRANSLATION_EDITOR_UPDATED',
	TRANSLATION_EDITOR_SAVE_REQUESTED = 'TRANSLATION_EDITOR_SAVE_REQUESTED',
	TRANSLATION_EDITOR_SAVE_SUCCEEDED = 'TRANSLATION_EDITOR_SAVE_SUCCEEDED',
	TRANSLATION_EDITOR_SAVE_FAILED = 'TRANSLATION_EDITOR_SAVE_FAILED',
	TRANSLATIONS_GET_REQUESTED = 'TRANSLATIONS_GET_REQUESTED',
	TRANSLATIONS_GET_SUCCEEDED = 'TRANSLATIONS_GET_SUCCEEDED',
	TRANSLATIONS_GET_FAILED = 'TRANSLATIONS_GET_FAILED',

	// TOAST NOTIFICATIONS
	TOAST_INFO_NOTIFICATION = 'TOAST_INFO_NOTIFICATION',
	TOAST_SUCCESS_NOTIFICATION = 'TOAST_SUCCESS_NOTIFICATION',
	TOAST_SUCCESS_GENERIC_NOTIFICATION = 'TOAST_SUCCESS_GENERIC_NOTIFICATION',
	TOAST_WARNING_NOTIFICATION = 'TOAST_WARNING_NOTIFICATION',
	TOAST_WARNING_CUSTOM_NOTIFICATION = 'TOAST_WARNING_CUSTOM_NOTIFICATION',
	TOAST_WARNING_GENERIC_NOTIFICATION = 'TOAST_WARNING_GENERIC_NOTIFICATION',
	TOAST_PROCESSING_NOTIFICATION = 'TOAST_PROCESSING_NOTIFICATION',
	TOAST_PROCESSING_GENERIC_NOTIFICATION = 'TOAST_PROCESSING_GENERIC_NOTIFICATION',
	TOAST_DISMISS_ALL = 'TOAST_DISMISS_ALL',

	// SIGNALR
	SIGNALR_PARTICPANT_MONITOR_COUNTS_CHANGED = 'SIGNALR_PARTICPANT_MONITOR_COUNTS_CHANGED',
	SIGNALR_SURVEY_DELETE_CHANGED = 'SIGNALR_SURVEY_DELETE_CHANGED',

	// REPORTING SETUP
	REPORTING_CLIENT_MIN_N_GET_FAILED = 'REPORTING_CLIENT_MIN_N_GET_FAILED',
	REPORTING_CLIENT_MIN_N_GET_REQUESTED = 'REPORTING_CLIENT_MIN_N_GET_REQUESTED',
	REPORTING_CLIENT_MIN_N_GET_SUCCEEDED = 'REPORTING_CLIENT_MIN_N_GET_SUCCEEDED',
	REPORTING_MIN_N_UPDATED = 'REPORTING_MIN_N_UPDATED',
	REPORTING_OVERRIDE_MIN_N_TOGGLED = 'REPORTING_OVERRIDE_MIN_N_TOGGLED',
	REPORTING_SETUP_GET_FAILED = 'REPORTING_SETUP_GET_FAILED',
	REPORTING_SETUP_GET_REQUESTED = 'REPORTING_SETUP_GET_REQUESTED',
	REPORTING_SETUP_GET_SUCCEEDED = 'REPORTING_SETUP_GET_SUCCEEDED',
	REPORTING_SETUP_SAVE_FAILED = 'REPORTING_SETUP_SAVE_FAILED',
	REPORTING_SETUP_SAVE_REQUESTED = 'REPORTING_SETUP_SAVE_REQUESTED',
	REPORTING_SETUP_SAVE_SUCCEEDED = 'REPORTING_SETUP_SAVE_SUCCEEDED',
	REPORTING_SETUP_TRENDSURVEYS_GET_FAILED = 'REPORTING_SETUP_TRENDSURVEYS_GET_FAILED',
	REPORTING_SETUP_TRENDSURVEYS_GET_REQUESTED = 'REPORTING_SETUP_TRENDSURVEYS_GET_REQUESTED',
	REPORTING_SETUP_TRENDSURVEYS_GET_SUCCEEDED = 'REPORTING_SETUP_TRENDSURVEYS_GET_SUCCEEDED',
	REPORTING_SETUP_TRENDGROUPS_GET_FAILED = 'REPORTING_SETUP_TRENDGROUPS_GET_FAILED',
	REPORTING_SETUP_TRENDGROUPS_GET_REQUESTED = 'REPORTING_SETUP_TRENDGROUPS_GET_REQUESTED',
	REPORTING_SETUP_TRENDGROUPS_GET_SUCCEEDED = 'REPORTING_SETUP_TRENDGROUPS_GET_SUCCEEDED',
	REPORTING_SETUP_UNMOUNT = 'REPORTING_SETUP_UNMOUNT',
	REPORTING_SETUP_UPDATE_TREND_GROUP = 'REPORTING_SETUP_UPDATE_TREND_GROUP',
	REPORTING_USERS_ADD_USER = 'REPORTING_USERS_ADD_USER',
	REPORTING_USERS_DELETE_USER = 'REPORTING_USERS_DELETE_USER',
	REPORTING_USERS_UPDATE_USER = 'REPORTING_USERS_UPDATE_USER',
	REPORTING_RESPONSE_STREAMING_FLAG_CHANGED = 'REPORTING_RESPONSE_STREAMING_FLAG_CHANGED',

	// REPORTING ACCESS
	REPORTING_ACCESS_ADD_USER = 'REPORTING_ACCESS_ADD_USER',
	REPORTING_ACCESS_DELETE_USER = 'REPORTING_ACCESS_DELETE_USER',
	REPORTING_ACCESS_GET_USERS_REQUESTED = 'REPORTING_ACCESS_GET_USERS_REQUESTED',
	REPORTING_ACCESS_GET_USERS_SUCCEEDED = 'REPORTING_ACCESS_GET_USERS_SUCCEEDED',
	REPORTING_ACCESS_HIERARCHIES_BEGIN_FETCHING = 'REPORTING_ACCESS_HIERARCHIES_BEGIN_FETCHING',
	REPORTING_ACCESS_HIERARCHIES_FETCHED = 'REPORTING_ACCESS_HIERARCHIES_FETCHED',
	REPORTING_ACCESS_HIERARCHIES_FAILED_TO_FETCH = 'REPORTING_ACCESS_HIERARCHIES_FAILED_TO_FETCH',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_ADD_FAILED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_ADD_FAILED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_ADD_REQUESTED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_ADD_REQUESTED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_ADD_SUCCEEDED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_ADD_SUCCEEDED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_DELETE_MODAL_CLOSE = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_DELETE_MODAL_CLOSE',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_DELETE_MODAL_OPEN = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_DELETE_MODAL_OPEN',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_DELETE_REQUESTED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_DELETE_REQUESTED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_DELETE_SUCCEEDED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_DELETE_SUCCEEDED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_EDIT_MODAL_CLOSE = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_EDIT_MODAL_CLOSE',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_EDIT_MODAL_OPEN = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_EDIT_MODAL_OPEN',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_GET_REQUESTED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_GET_REQUESTED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_GET_SUCCEEDED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_GET_SUCCEEDED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_UPDATE_FAILED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_UPDATE_FAILED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_UPDATE_REQUESTED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_UPDATE_REQUESTED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_UPDATE_SUCCEEDED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_UPDATE_SUCCEEDED',
	REPORTING_ACCESS_HIERARCHY_CONFIGS_UPDATE_USER_COUNT_SUCCEEDED = 'REPORTING_ACCESS_HIERARCHY_CONFIGS_UPDATE_USER_COUNT_SUCCEEDED',

	REPORTING_ACCESS_HIERARCHY_SECTION_INITIALIZE_SUCCEEDED = 'REPORTING_ACCESS_HIERARCHY_SECTION_INITIALIZE_SUCCEEDED',
	REPORTING_ACCESS_NOTIFY_USER_FAILED = 'REPORTING_ACCESS_NOTIFY_USER_FAILED',
	REPORTING_ACCESS_NOTIFY_USER_REQUESTED = 'REPORTING_ACCESS_NOTIFY_USER_REQUESTED',
	REPORTING_ACCESS_NOTIFY_USER_SUCCEEDED = 'REPORTING_ACCESS_NOTIFY_USER_SUCCEEDED',
	REPORTING_ACCESS_PROFILES_BEGIN_FETCHING = 'REPORTING_ACCESS_PROFILES_BEGIN_FETCHING',
	REPORTING_ACCESS_PROFILES_FETCHED = 'REPORTING_ACCESS_PROFILES_FETCHED',
	REPORTING_ACCESS_PROFILES_FAILED_TO_FETCH = 'REPORTING_ACCESS_PROFILES_FAILED_TO_FETCH',
	REPORTING_ACCESS_PROFILES_SECTION_CONFIG_SAVE_REQUESTED = 'REPORTING_ACCESS_PROFILES_SECTION_CONFIG_SAVE_REQUESTED',
	REPORTING_ACCESS_PROFILES_SECTION_CONFIG_SAVE_SUCCEEDED = 'REPORTING_ACCESS_PROFILES_SECTION_CONFIG_SAVE_SUCCEEDED',
	REPORTING_ACCESS_PROFILES_SECTION_CONFIG_UPDATE_USER_COUNT_SUCCEEDED = 'REPORTING_ACCESS_PROFILES_SECTION_CONFIG_UPDATE_USER_COUNT_SUCCEEDED',
	REPORTING_ACCESS_PROFILES_SECTION_CONFIG_SAVE_FAILED = 'REPORTING_ACCESS_PROFILES_SECTION_CONFIG_SAVE_FAILED',
	REPORTING_ACCESS_PROFILES_SECTION_EDIT_MODAL_CLOSE = 'REPORTING_ACCESS_PROFILES_SECTION_EDIT_MODAL_CLOSE',
	REPORTING_ACCESS_PROFILES_SECTION_EDIT_MODAL_OPEN = 'REPORTING_ACCESS_PROFILES_SECTION_EDIT_MODAL_OPEN',
	REPORTING_ACCESS_PROFILES_SECTION_INITIALIZE_SUCCEEDED = 'REPORTING_ACCESS_PROFILES_SECTION_INITIALIZE_SUCCEEDED',
	REPORTING_ACCESS_SAVE_USERS_REQUESTED = 'REPORTING_ACCESS_SAVE_USERS_REQUESTED',
	REPORTING_ACCESS_SAVE_USERS_SUCCEEDED = 'REPORTING_ACCESS_SAVE_USERS_SUCCEEDED',
	REPORTING_ACCESS_SAVE_USERS_FAILED = 'REPORTING_ACCESS_SAVE_USERS_FAILED',
	REPORTING_ACCESS_UPDATE_USER = 'REPORTING_ACCESS_UPDATE_USER',
	REPORTING_SURVEY_MIN_N_GET_REQUESTED = 'REPORTING_SURVEY_MIN_N_GET_REQUESTED',
	REPORTING_SURVEY_MIN_N_GET_SUCCEEDED = 'REPORTING_SURVEY_MIN_N_GET_SUCCEEDED',
	REPORTING_SURVEY_MIN_N_GET_FAILED = 'REPORTING_SURVEY_MIN_N_GET_FAILED',
	REPORTING_SURVEY_MIN_N_SAVE_REQUESTED = 'REPORTING_SURVEY_MIN_N_SAVE_REQUESTED',
	REPORTING_SURVEY_MIN_N_SAVE_SUCCEEDED = 'REPORTING_SURVEY_MIN_N_SAVE_SUCCEEDED',
	REPORTING_SURVEY_MIN_N_SAVE_FAILED = 'REPORTING_SURVEY_MIN_N_SAVE_FAILED',

	// SURVEY SUMMARY ITEMS
	SURVEYSUMMARYITEMS_GET_REQUESTED = 'SURVEYSUMMARYITEMS_GET_REQUESTED',
	SURVEYSUMMARYITEMS_GET_FAILED = 'SURVEYSUMMARYITEMS_GET_FAILED',
	SURVEYSUMMARYITEMS_GET_SUCCEEDED = 'SURVEYSUMMARYITEMS_GET_SUCCEEDED',

	// SURVEY ADMIN
	SURVEY_ADMIN_SUMMARY_GET_REQUESTED = 'SURVEY_ADMIN_SUMMARY_GET_REQUESTED',
	SURVEY_ADMIN_SUMMARY_GET_SUCCEEDED = 'SURVEY_ADMIN_SUMMARY_GET_SUCCEEDED',
	SURVEY_ADMIN_SUMMARY_GET_FAILED = 'SURVEY_ADMIN_SUMMARY_GET_FAILED',
	SURVEY_ADMIN_AUDIENCES_GET_REQUESTED = 'SURVEY_ADMIN_AUDIENCES_GET_REQUESTED',
	SURVEY_ADMIN_AUDIENCES_GET_SUCCEEDED = 'SURVEY_ADMIN_AUDIENCES_GET_SUCCEEDED',
	SURVEY_ADMIN_OPEN_CLOSE_DATE_UPDATE = 'SURVEY_ADMIN_OPEN_CLOSE_UPDATE',

	// PARTICIPATION MONITOR
	AUDIENCE_PARTICIPATION_COUNTS_GET_REQUESTED = 'AUDIENCE_PARTICIPATION_COUNTS_GET_REQUESTED',
	AUDIENCE_PARTICIPATION_COUNTS_GET_SUCCEEDED = 'AUDIENCE_PARTICIPATION_COUNTS_GET_SUCCEEDED',

	// IMPORT RESTART
	RESTART_DATASET_IMPORT_REQUESTED = 'RESTART_DATASET_IMPORT_REQUESTED',
	RESTART_DATASET_IMPORT_SUCCEEDED = 'RESTART_DATASET_IMPORT_SUCCEEDED',

	RESTART_DATASET_IMPORT_MSUITE_CLIENT_GUID_CHANGED = 'RESTART_DATASET_IMPORT_MSUITE_CLIENT_GUID_CHANGED',
	RESTART_DATASET_IMPORT_MSUITE_DATASET_ID_CHANGED = 'RESTART_DATASET_IMPORT_MSUITE_DATASET_ID_CHANGED',
	RESTART_DATASET_IMPORT_MRESEARCH_EVTASSGID_CHANGED = 'RESTART_DATASET_IMPORT_MRESEARCH_EVTASSGID_CHANGED',

	// SURVEY BENCHMARKS
	SURVEY_BENCHMARKS_GET_REQUESTED = 'SURVEY_BENCHMARKS_GET_REQUESTED',
	SURVEY_BENCHMARKS_GET_SUCCEEDED = 'SURVEY_BENCHMARKS_GET_SUCCEEDED',
	SURVEY_BENCHMARKS_SAVE_REQUESTED = 'SURVEY_BENCHMARKS_SAVE_REQUESTED',
	SURVEY_BENCHMARKS_SAVE_SUCCEEDED = 'SURVEY_BENCHMARKS_SAVE_SUCCEEDED',

	// EMAIL
	SEND_EMAIL_REQUESTED = 'SEND_EMAIL_REQUESTED',
	SEND_EMAIL_SUCCEEDED = 'SEND_EMAIL_SUCCEEDED',
	SEND_EMAIL_FAILED = 'SEND_EMAIL_FAILED',
	TOGGLE_SEND_EMAIL_MODAL = 'TOGGLE_SEND_EMAIL_MODAL',
	GET_PREVIEW_URL_REQUESTED = 'GET_PREVIEW_URL_REQUESTED',
	GET_PREVIEW_URL_SUCCEEDED = 'GET_PREVIEW_URL_SUCCEEDED',
	GET_PREVIEW_URL_FAILED = 'GET_PREVIEW_URL_FAILED',
	GET_EMAIL_TEMPLATE_REQUESTED = 'GET_EMAIL_TEMPLATE_REQUESTED',
	GET_EMAIL_TEMPLATE_SUCCEEDED = 'GET_EMAIL_TEMPLATE_SUCCEEDED',
	GET_EMAIL_TEMPLATE_FAILED = 'GET_EMAIL_TEMPLATE_FAILED',

	// EMAIL TEMPLATE
	AUDIENCE_EMAILTEMPLATES_REQUESTED = 'AUDIENCE_EMAILTEMPLATES_REQUESTED',
	AUDIENCE_EMAILTEMPLATES_SUCCEEDED = 'AUDIENCE_EMAILTEMPLATES_SUCCEEDED',
	AUDIENCE_EMAILTEMPLATES_FAILED = 'AUDIENCE_EMAILTEMPLATES_FAILED',

	AUDIENCE_EMAILTEMPLATE_ADD_REQUESTED = 'AUDIENCE_EMAILTEMPLATE_ADD_REQUESTED',
	AUDIENCE_EMAILTEMPLATE_ADD_SUCCEEDED = 'AUDIENCE_EMAILTEMPLATE_ADD_SUCCEEDED',
	AUDIENCE_EMAILTEMPLATE_ADD_FAILED = 'AUDIENCE_EMAILTEMPLATE_ADD_FAILED',

	AUDIENCE_EMAILTEMPLATE_UPDATE_REQUESTED = 'AUDIENCE_EMAILTEMPLATE_UPDATE_REQUESTED',
	AUDIENCE_EMAILTEMPLATE_UPDATE_SUCCEEDED = 'AUDIENCE_EMAILTEMPLATE_UPDATE_SUCCEEDED',
	AUDIENCE_EMAILTEMPLATE_UPDATE_FAILED = 'AUDIENCE_EMAILTEMPLATE_UPDATE_FAILED',

	AUDIENCE_EMAILTEMPLATE_DELETE_REQUESTED = 'AUDIENCE_EMAILTEMPLATE_DELETE_REQUESTED',
	AUDIENCE_EMAILTEMPLATE_DELETE_SUCCEEDED = 'AUDIENCE_EMAILTEMPLATE_DELETE_SUCCEEDED',
	AUDIENCE_EMAILTEMPLATE_DELETE_FAILED = 'AUDIENCE_EMAILTEMPLATE_DELETE_FAILED',
	EMAILTEMPLATE_ARCHIVE_SUCCEEDED = 'EMAILTEMPLATE_ARCHIVE_SUCCEEDED',
	EMAILTEMPLATE_ARCHIVE_FAILED = 'EMAILTEMPLATE_ARCHIVE_FAILED',

	AUDIENCE_INVITATIONEMAIL_VALIDATION = 'AUDIENCE_INVITATIONEMAIL_VALIDATION',
	AUDIENCE_REMINDER_EMAIL_VALIDATION = 'AUDIENCE_REMINDER_EMAIL_VALIDATION',
	AUDIENCE_EMAILTEMPLATE_ACCESSCODE_REMOVE = 'AUDIENCE_EMAILTEMPLATE_ACCESSCODE_REMOVE',

	AUDIENCE_SAVE_REMINDER_SUCCEEDED = 'AUDIENCE_SAVE_REMINDER_SUCCEEDED',
	AUDIENCE_DELETE_REMINDER_SUCCEEDED = 'AUDIENCE_DELETE_REMINDER_SUCCEEDED',
	AUDIENCE_INVITATIONEMAIL_UPDATE_SUCCEEDED = 'AUDIENCE_INVITATIONEMAIL_UPDATE_SUCCEEDED',

	// STEPPER
	SURVEY_BUILDER_INITIALIZE = 'SURVEY_BUILDER_INITIALIZE',
	SURVEY_BUILDER_RESET = 'SURVEY_BUILDER_RESET',
	STEPPER_SAVE_REQUESTED = 'STEPPER_SAVE_REQUESTED',
	STEPPER_SAVE_COMPLETE = 'STEPPER_SAVE_COMPLETE',
	STEPPER_SAVE_FAILED = 'STEPPER_SAVE_FAILED',
	STEPPER_VALIDATION_FAILED = 'STEPPER_VALIDATION_FAILED',
	STEPPER_VALIDATION_CLEARED = 'STEPPER_VALIDATION_CLEARED',
	STEPPER_ROUTING_COMPLETE = 'STEPPER_ROUTING_COMPLETE',
	STEPPER_ROUTING_REQUESTED = 'STEPPER_ROUTING_REQUESTED',
	STEPPER_ROUTING_CANCELED = 'STEPPER_ROUTING_CANCELED',
	STEPPER_ROUTING_DISCARD_CHANGES = 'STEPPER_ROUTING_DISCARD_CHANGES',
	STEPPER_UNSAVED_CHANGES_ANALYSIS = 'STEPPER_UNSAVED_CHANGES_ANALYSIS',

	// DISTRIBUTIONS
	DISTRIBUTIONS_GET_REQUESTED = 'DISTRIBUTIONS_GET_REQUESTED',
	DISTRIBUTIONS_GET_FAILED = 'DISTRIBUTIONS_GET_FAILED',
	DISTRIBUTIONS_GET_SUCCEEDED = 'DISTRIBUTIONS_GET_SUCCEEDED',
	DISTRIBUTION_DELETE_REQUESTED = 'DISTRIBUTION_DELETE_REQUESTED',
	DISTRIBUTION_DELETE_FAILED = 'DISTRIBUTION_DELETE_FAILED',
	DISTRIBUTION_DELETE_SUCCEEDED = 'DISTRIBUTION_DELETE_SUCCEEDED',
	DISTRIBUTION_ARCHIVE_REQUESTED = 'DISTRIBUTION_ARCHIVE_REQUESTED',
	DISTRIBUTION_ARCHIVE_FAILED = 'DISTRIBUTION_ARCHIVE_FAILED',
	DISTRIBUTION_ARCHIVE_SUCCEEDED = 'DISTRIBUTION_ARCHIVE_SUCCEEDED',
	DISTRIBUTION_REMOVE_FROM_LIST = 'DISTRIBUTION_REMOVE_FROM_LIST',
	DISTRIBUTION_DOWNLOAD_LIST_REQUESTED = 'DISTRIBUTION_DOWNLOAD_LIST_REQUESTED',
	DISTRIBUTION_DOWNLOAD_LIST_FAILED = 'DISTRIBUTION_DOWNLOAD_LIST_FAILED',
	DISTRIBUTION_DOWNLOAD_LIST_SUCCEEDED = 'DISTRIBUTION_DOWNLOAD_LIST_SUCCEEDED',
	DISTRIBUTION_DOWNLOAD_TEMPLATE_REQUESTED = 'DISTRIBUTION_DOWNLOAD_TEMPLATE_REQUESTED',
	DISTRIBUTION_DOWNLOAD_TEMPLATE_FAILED = 'DISTRIBUTION_DOWNLOAD_TEMPLATE_FAILED',
	DISTRIBUTION_DOWNLOAD_TEMPLATE_SUCCEEDED = 'DISTRIBUTION_DOWNLOAD_TEMPLATE_SUCCEEDED',
	DISTRIBUTION_INIT_STATE = 'DISTRIBUTION_INIT_STATE',
	DISTRIBUTION_CLEAR_VALIDATION = 'DISTRIBUTION_CLEAR_VALIDATION',
	DISTRIBUTION_LIST_VALIDATION = 'DISTRIBUTION_LIST_VALIDATION',

	DISTRIBUTION_VALIDATE_FILE_REQUESTED = 'DISTRIBUTION_VALIDATE_FILE_REQUESTED',
	DISTRIBUTION_VALIDATE_FILE_FAILED = 'DISTRIBUTION_VALIDATE_FILE_FAILED',
	DISTRIBUTION_VALIDATE_FILE_SUCCEEDED = 'DISTRIBUTION_VALIDATE_FILE_SUCCEEDED',
	DISTRIBUTION_ADD_REQUESTED = 'DISTRIBUTION_ADD_REQUESTED',
	DISTRIBUTION_ADD_FAILED = 'DISTRIBUTION_ADD_FAILED',
	DISTRIBUTION_ADD_SUCCEEDED = 'DISTRIBUTION_ADD_SUCCEEDED',
	DISTRIBUTION_APPEND_REQUESTED = 'DISTRIBUTION_APPEND_REQUESTED',
	DISTRIBUTION_APPEND_FAILED = 'DISTRIBUTION_APPEND_FAILED',
	DISTRIBUTION_APPEND_SUCCEEDED = 'DISTRIBUTION_APPEND_SUCCEEDED',

	DISTRIBUTION_OPTION_DATA_TRANSFER_VALIDATE_FILE_REQUESTED = 'DISTRIBUTION_OPTION_DATA_TRANSFER_VALIDATE_FILE_REQUESTED',
	DISTRIBUTION_OPTION_DATA_TRANSFER_VALIDATE_FILE_SUCCEEDED = 'DISTRIBUTION_OPTION_DATA_TRANSFER_VALIDATE_FILE_SUCCEEDED',
	DISTRIBUTION_OPTION_DATA_TRANSFER_VALIDATE_FILE_FAILED = 'DISTRIBUTION_OPTION_DATA_TRANSFER_VALIDATE_FILE_FAILED',

	DISTRIBUTIONHIERARCHY_GET_REQUESTED = 'DISTRIBUTIONHIERARCHY_GET_REQUESTED',
	DISTRIBUTIONHIERARCHY_GET_SUCCEEDED = 'DISTRIBUTIONHIERARCHY_GET_SUCCEEDED',
	DISTRIBUTIONHIERARCHY_GET_FAILED = 'DISTRIBUTIONHIERARCHY_GET_FAILED',
	DISTRIBUTIONHIERARCHY_SELECT_HIERARCHY = 'DISTRIBUTIONHIERARCHY_SELECT_HIERARCHY',
	DISTRIBUTIONHIERARCHY_UPDATE_HIERARCHYSELECTION = 'DISTRIBUTIONHIERARCHY_UPDATE_HIERARCHYSELECTION',
	DISTRIBUTIONHIERARCHY_SAVE_REQUESTED = 'DISTRIBUTIONHIERARCHY_SAVE_REQUESTED',
	DISTRIBUTIONHIERARCHY_SAVE_SUCCEEDED = 'DISTRIBUTIONHIERARCHY_SAVE_SUCCEEDED',
	DISTRIBUTIONHIERARCHY_SAVE_FAILED = 'DISTRIBUTIONHIERARCHY_SAVE_FAILED',
	DISTRIBUTION_AUTOSELECT_HIERARCHYTOPNODES = 'DISTRIBUTION_AUTOSELECT_HIERARCHYTOPNODES',
	DISTRIBUTIONHIERARCHY_INIT_STATE = 'DISTRIBUTIONHIERARCHY_INIT_STATE',
	DISTRIBUTIONHIERARCHY_VALIDATION_FAILED = 'DISTRIBUTIONHIERARCHY_VALIDATION_FAILED',
	DISTRIBUTIONHIERARCHY_ACCESS_CODE_UPLOAD_SUCCEEDED = 'DISTRIBUTIONHIERARCHY_ACCESS_CODE_UPLOAD_SUCCEEDED',
	DISTRIBUTIONHIERARCHY_ACCESS_CODE_UPLOAD_FAILED = 'DISTRIBUTIONHIERARCHY_ACCESS_CODE_UPLOAD_FAILED',

	// HRIS List
	HIERARCHY_GET_HRIS_LIST_REQUESTED = 'HIERARCHY_GET_HRIS_LIST_REQUESTED',
	HIERARCHY_GET_HRIS_LIST_SUCCEEDED = 'HIERARCHY_GET_HRIS_LIST_SUCCEEDED',
	HIERARCHY_GET_HRIS_LIST_FAILED = 'HIERARCHY_GET_HRIS_LIST_FAILED',

	// HRIS Hierarchy
	HIERARCHY_GET_HRIS_HIERARCHY_REQUESTED = 'HIERARCHY_GET_HRIS_HIERARCHY_REQUESTED',
	HIERARCHY_GET_HRIS_HIERARCHY_SUCCEEDED = 'HIERARCHY_GET_HRIS_HIERARCHY_SUCCEEDED',
	HIERARCHY_GET_HRIS_HIERARCHY_FAILED = 'HIERARCHY_GET_HRIS_HIERARCHY_FAILED',

	// Hierarchy
	HIERARCHY_GET_LIST_REQUESTED = 'HIERARCHY_GET_LIST_REQUESTED',
	HIERARCHY_GET_LIST_SUCCEEDED = 'HIERARCHY_GET_LIST_SUCCEEDED',
	HIERARCHY_GET_LIST_FAILED = 'HIERARCHY_GET_LIST_FAILED',
	HIERARCHY_GET_HIERARCHY_VM_REQUESTED = 'HIERARCHY_GET_HIERARCHY_VM_REQUESTED',
	HIERARCHY_GET_HIERARCHY_VM_SUCCEEDED = 'HIERARCHY_GET_HIERARCHY_VM_SUCCEEDED',
	HIERARCHY_GET_HIERARCHY_VM_FAILED = 'HIERARCHY_GET_HIERARCHY_VM_FAILED',
	HIERARCHY_GET_HIERARCHY_ALL_NODES_SUCCEEDED = 'HIERARCHY_GET_HIERARCHY_ALL_NODES_SUCCEEDED',
	HIERARCHY_GET_HIERARCHY_METRICS_SUCCEEDED = 'HIERARCHY_GET_HIERARCHY_METRICS_SUCCEEDED',
	HIERARCHY_RESET_STATE = 'HIERARCHY_RESET_STATE',

	// Disconnected Hierarchy
	HIERARCHY_GET_DISCONNECTED_HIERARCHY_REQUESTED = 'HIERARCHY_GET_DISCONNECTED_HIERARCHY_REQUESTED',
	HIERARCHY_GET_DISCONNECTED_HIERARCHY_SUCCEEDED = 'HIERARCHY_GET_DISCONNECTED_HIERARCHY_SUCCEEDED',
	HIERARCHY_GET_DISCONNECTED_HIERARCHY_FAILED = 'HIERARCHY_GET_DISCONNECTED_HIERARCHY_FAILED',

	// Distribution Contacts
	DISTRIBUTION_CONTACTS_GET_REQUESTED = 'DISTRIBUTION_CONTACTS_GET_REQUESTED',
	DISTRIBUTION_CONTACTS_GET_SUCCEEDED = 'DISTRIBUTION_CONTACTS_GET_SUCCEEDED',
	DISTRIBUTION_CONTACTS_GET_FAILED = 'DISTRIBUTION_CONTACTS_GET_FAILED',
	DISTRIBUTION_CONTACTS_COUNT_GET_REQUESTED = 'DISTRIBUTION_CONTACTS_COUNT_GET_REQUESTED',
	DISTRIBUTION_CONTACTS_COUNT_GET_SUCCEEDED = 'DISTRIBUTION_CONTACTS_COUNT_GET_SUCCEEDED',
	DISTRIBUTION_CONTACTS_COUNT_GET_FAILED = 'DISTRIBUTION_CONTACTS_COUNT_GET_FAILED',
	DISTRIBUTION_CONTACTS_MODAL_OPEN = 'DISTRIBUTION_CONTACTS_MODAL_OPEN',
	DISTRIBUTION_CONTACTS_MODAL_CLOSE = 'DISTRIBUTION_CONTACTS_MODAL_CLOSE',
	DISTRIBUTION_CONTACT_DELETE_REQUESTED = 'DISTRIBUTION_CONTACT_DELETE_REQUESTED',
	DISTRIBUTION_CONTACT_DELETE_FAILED = 'DISTRIBUTION_CONTACT_DELETE_FAILED',
	DISTRIBUTION_CONTACT_DELETE_SUCCEEDED = 'DISTRIBUTION_CONTACT_DELETE_SUCCEEDED',
	DISTRIBUTION_CONTACT_SELECT = 'DISTRIBUTION_CONTACT_SELECT',
	DISTRIBUTION_CONTACT_ADD_SELECTED = 'DISTRIBUTION_CONTACT_ADD_SELECTED',
	DISTRIBUTION_CONTACT_REMOVE_SELECTED = 'DISTRIBUTION_CONTACT_REMOVE_SELECTED',
	DISTRIBUTION_CONTACT_MULTIPLE_DELETE_REQUESTED = 'DISTRIBUTION_CONTACT_MULTIPLE_DELETE_REQUESTED',
	DISTRIBUTION_CONTACT_MULTIPLE_DELETE_FAILED = 'DISTRIBUTION_CONTACT_MULTIPLE_DELETE_FAILED',
	DISTRIBUTION_CONTACT_MULTIPLE_DELETE_SUCCEEDED = 'DISTRIBUTION_CONTACT_MULTIPLE_DELETE_SUCCEEDED',
	DISTRIBUTION_CONTACT_TOGGLE_DELETE_WARNING_MODAL = 'DISTRIBUTION_CONTACT_TOGGLE_DELETE_WARNING_MODAL',
	DISTRIBUTION_CONTACT_UPDATE_STATUS_AFTER_REOPEN = 'DISTRIBUTION_CONTACT_UPDATE_STATUS_AFTER_REOPEN',
	DISTRIBUTION_CONTACT_UPDATE_STATUS_AFTER_RESET = 'DISTRIBUTION_CONTACT_UPDATE_STATUS_AFTER_RESET',
	DISTRIBUTION_CONTACT_CLEAR_SELECTED = 'DISTRIBUTION_CONTACT_CLEAR_SELECTED',
	DISTRIBUTION_CONTACTS_TOGGLE_DUPLICATE_EMAIL_SWITCH = 'DISTRIBUTION_CONTACTS_TOGGLE_DUPLICATE_EMAIL_SWITCH',
	DISTRIBUTION_CONTACTS_SET_DISPLAY_DUPLICATE_EMAIL_STATE = 'DISTRIBUTION_CONTACTS_SET_DISPLAY_DUPLICATE_EMAIL_STATE',

	// Client Attributes
	CLIENT_PARTICIPANT_ATTRIBUTE_GET_REQUESTED = 'CLIENT_PARTICIPANT_ATTRIBUTE_GET_REQUESTED',
	CLIENT_PARTICIPANT_ATTRIBUTE_GET_SUCCEEDED = 'CLIENT_PARTICIPANT_ATTRIBUTE_GET_SUCCEEDED',
	CLIENT_PARTICIPANT_ATTRIBUTE_GET_FAILED = 'CLIENT_PARTICIPANT_ATTRIBUTE_GET_FAILED',
	CLIENT_PARTICIPANT_ATTRIBUTE_ADD_SELECTED_BYCOLUMN = 'CLIENT_PARTICIPANT_ATTRIBUTE_ADD_SELECTED_BYCOLUMN',
	CLIENT_PARTICIPANT_ATTRIBUTE_REMOVE_SELECTED_BYCOLUMN = 'CLIENT_PARTICIPANT_ATTRIBUTE_REMOVE_SELECTED_BYCOLUMN',
	CLIENT_PARTICIPANT_ATTRIBUTE_ADD_SELECTED_BYNAME = 'CLIENT_PARTICIPANT_ATTRIBUTE_ADD_SELECTED_BYNAME',
	CLIENT_PARTICIPANT_ATTRIBUTE_REMOVE_SELECTED_BYNAME = 'CLIENT_PARTICIPANT_ATTRIBUTE_REMOVE_SELECTED_BYNAME',
	CLIENT_PARTICIPANT_ATTRIBUTE_REPLACE_SELECTED = 'CLIENT_PARTICIPANT_ATTRIBUTE_REPLACE_SELECTED',

	// Distribution contacts display columns
	DISTRIBUTION_CONTACTS_COLUMNS_GET_REQUESTED = 'DISTRIBUTION_CONTACTS_COLUMNS_GET_REQUESTED',
	DISTRIBUTION_CONTACTS_COLUMNS_GET_SUCCEEDED = 'DISTRIBUTION_CONTACTS_COLUMNS_GET_SUCCEEDED',
	DISTRIBUTION_CONTACTS_COLUMNS_GET_FAILED = 'DISTRIBUTION_CONTACTS_COLUMNS_GET_FAILED',
	DISTRIBUTION_CONTACTS_RESET_DEFAULT_COLUMNS = 'DISTRIBUTION_CONTACTS_RESET_DEFAULT_COLUMNS',
	RESET_RESEND_REOPEN_DEFAULT_COLUMNS = 'RESET_RESEND_REOPEN_DEFAULT_COLUMNS',

	// Trending Results Admin
	SURVEY_ADMIN_TRENDGROUPS_GET_REQUESTED = 'SURVEY_ADMIN_TRENDGROUPS_GET_REQUESTED',
	SURVEY_ADMIN_TRENDGROUPS_GET_SUCCEEDED = 'SURVEY_ADMIN_TRENDGROUPS_GET_SUCCEEDED',
	SURVEY_ADMIN_TRENDGROUPS_GET_FAILED = 'SURVEY_ADMIN_TRENDGROUPS_GET_FAILED',
	SURVEY_ADMIN_TRENDSURVEYS_GET_REQUESTED = 'SURVEY_ADMIN_TRENDSURVEYS_GET_REQUESTED',
	SURVEY_ADMIN_TRENDSURVEYS_GET_SUCCEEDED = 'SURVEY_ADMIN_TRENDSURVEYS_GET_SUCCEEDED',
	SURVEY_ADMIN_TRENDSURVEYS_GET_FAILED = 'SURVEY_ADMIN_TRENDSURVEYS_GET_FAILED',
	SURVEY_ADMIN_TRENDGROUPS_ID_GET_REQUESTED = 'SURVEY_ADMIN_TRENDGROUPS_ID_GET_REQUESTED',
	SURVEY_ADMIN_TRENDGROUPS_ID_GET_SUCCEEDED = 'SURVEY_ADMIN_TRENDGROUPS_ID_GET_SUCCEEDED',
	SURVEY_ADMIN_TRENDGROUPS_ID_GET_FAILED = 'SURVEY_ADMIN_TRENDGROUPS_ID_GET_FAILED',
	SURVEY_ADMIN_UPDATE_TREND_GROUPS = 'SURVEY_ADMIN_UPDATE_TREND_GROUPS',
	SURVEY_ADMIN_TRENDGROUPS_UPDATE_ID_REQUESTED = 'SURVEY_ADMIN_TRENDGROUPS_UPDATE_ID_REQUESTED',
	SURVEY_ADMIN_TRENDGROUPS_UPDATE_ID_SUCCEEDED = 'SURVEY_ADMIN_TRENDGROUPS_UPDATE_ID_SUCCEEDED',
	SURVEY_ADMIN_TRENDGROUPS_UPDATE_ID_FAILED = 'SURVEY_ADMIN_TRENDGROUPS_UPDATE_ID_FAILED',
	SURVEY_ADMIN_TRENDGROUPS_UPDATE_TRENDGROUPID = 'SURVEY_ADMIN_TRENDGROUPS_UPDATE_TRENDGROUPID',

	// SURVEY PARTICIPANTS RESEND
	SURVEY_PARTICIPANT_RESEND_EMAIL_REQUESTED = 'SURVEY_PARTICIPANT_RESEND_EMAIL_REQUESTED',
	SURVEY_PARTICIPANT_RESEND_EMAIL_SUCCEEDED = 'SURVEY_PARTICIPANT_RESEND_EMAIL_SUCCEEDED',
	SURVEY_PARTICIPANT_RESEND_EMAIL_FAILED = 'SURVEY_PARTICIPANT_RESEND_EMAIL_FAILED',
	SURVEY_PARTICIPANT_RESEND_EMAIL_WARNING_MODAL_TOGGLE = 'SURVEY_PARTICIPANT_RESEND_EMAIL_WARNING_MODAL_TOGGLE',

	// SURVEY PARTICIPANTS REOPEN
	SURVEY_PARTICIPANT_REOPEN_REQUESTED = 'SURVEY_PARTICIPANT_REOPEN_REQUESTED',
	SURVEY_PARTICIPANT_REOPEN_SUCCEEDED = 'SURVEY_PARTICIPANT_REOPEN_SUCCEEDED',
	SURVEY_PARTICIPANT_REOPEN_FAILED = 'SURVEY_PARTICIPANT_REOPEN_FAILED',
	SURVEY_PARTICIPANT_REOPEN_WARNING_MODAL_TOGGLE = 'SURVEY_PARTICIPANT_REOPEN_WARNING_MODAL_TOGGLE',
	SURVEY_PARTICIPANT_REOPEN_RESEND_CHECKBOX_TOGGLE = 'SURVEY_PARTICIPANT_REOPEN_RESEND_CHECKBOX_TOGGLE',

	// SURVEY PARTICIPANTS RESET
	SURVEY_PARTICIPANT_RESET_REQUESTED = 'SURVEY_PARTICIPANT_RESET_REQUESTED',
	SURVEY_PARTICIPANT_RESET_SUCCEEDED = 'SURVEY_PARTICIPANT_RESET_SUCCEEDED',
	SURVEY_PARTICIPANT_RESET_FAILED = 'SURVEY_PARTICIPANT_RESET_FAILED',
	SURVEY_PARTICIPANT_RESET_WARNING_MODAL_TOGGLE = 'SURVEY_PARTICIPANT_RESET_WARNING_MODAL_TOGGLE',
	SURVEY_PARTICIPANT_RESET_RESEND_CHECKBOX_TOGGLE = 'SURVEY_PARTICIPANT_RESET_RESEND_CHECKBOX_TOGGLE',

	// PARTICIPATION MONITOR ATTRIBUTES
	PARTICIPATION_MONITOR_ATTRIBUTES_UPDATE_SELECTED = 'PARTICIPATION_MONITOR_ATTRIBUTES_UPDATE_SELECTED',
	PARTICIPATION_MONITOR_HIERARCHIES_UPDATE_SELECTED = 'PARTICIPATION_MONITOR_HIERARCHIES_UPDATE_SELECTED',
	PARTICIPATION_MONITOR_MISSING_BREAKOUTS_UPDATED = 'PARTICIPATION_MONITOR_MISSING_BREAKOUTS_UPDATED',
	REPORTING_SETUP_HRIS_FILE_SUMMARY_GET_REQUESTED = 'REPORTING_SETUP_HRIS_FILE_SUMMARY_GET_REQUESTED',
	REPORTING_SETUP_HRIS_FILE_SUMMARY_GET_FAILED = 'REPORTING_SETUP_HRIS_FILE_SUMMARY_GET_FAILED',
	REPORTING_SETUP_HRIS_FILE_SUMMARY_GET_SUCCEEDED = 'REPORTING_SETUP_HRIS_FILE_SUMMARY_GET_SUCCEEDED',
	REPORTING_SETUP_PARTICIPANT_ATTRIBUTES_GET_REQUESTED = 'REPORTING_SETUP_PARTICIPANT_ATTRIBUTES_GET_REQUESTED',
	REPORTING_SETUP_PARTICIPANT_ATTRIBUTES_GET_FAILED = 'REPORTING_SETUP_PARTICIPANT_ATTRIBUTES_GET_FAILED',
	REPORTING_SETUP_PARTICIPANT_ATTRIBUTES_GET_SUCCEEDED = 'REPORTING_SETUP_PARTICIPANT_ATTRIBUTES_GET_SUCCEEDED',
	REPORTING_SETUP_HRIS_ATTRIBUTES_GET_REQUESTED = 'REPORTING_SETUP_HRIS_ATTRIBUTES_GET_REQUESTED',
	REPORTING_SETUP_HRIS_ATTRIBUTES_GET_FAILED = 'REPORTING_SETUP_HRIS_ATTRIBUTES_GET_FAILED',
	REPORTING_SETUP_HRIS_ATTRIBUTES_GET_SUCCEEDED = 'REPORTING_SETUP_HRIS_ATTRIBUTES_GET_SUCCEEDED',
	REPORTING_SETUP_PARTICIPANT_NO_SOURCE = 'REPORTING_SETUP_PARTICIPANT_NO_SOURCE',

	// SURVEY LOGO
	SURVEY_IMAGE_FILE_CHANGED = 'SURVEY_IMAGE_FILE_CHANGED',
	SURVEY_IMAGE_FILE_REMOVED = 'SURVEY_IMAGE_FILE_REMOVED',
	SURVEY_IMAGE_DISPLAY_NAME_CHANGED = 'SURVEY_IMAGE_DISPLAY_NAME_CHANGED',
	SURVEY_IMAGE_PLACEMENT_CHANGED = 'SURVEY_IMAGE_PLACEMENT_CHANGED',
	SURVEY_IMAGE_GET_REQUESTED = 'SURVEY_IMAGE_GET_REQUESTED',
	SURVEY_IMAGE_GET_SUCCEEDED = 'SURVEY_IMAGE_GET_SUCCEEDED',
	SURVEY_IMAGE_GET_FAILED = 'SURVEY_IMAGE_GET_FAILED',

	// QUESTION CHANGES
	SURVEY_SINGLE_QUESTION_CHANGES_GET_REQUESTED = 'SURVEY_SINGLE_QUESTION_CHANGES_GET_REQUESTED',
	SURVEY_SINGLE_QUESTION_CHANGES_GET_SUCCEEDED = 'SURVEY_SINGLE_QUESTION_CHANGES_GET_SUCCEEDED',
	SURVEY_SINGLE_QUESTION_CHANGES_GET_FAILED = 'SURVEY_SINGLE_QUESTION_CHANGES_GET_FAILED',
	SURVEY_QUESTION_CHANGES_GET_REQUESTED = 'SURVEY_QUESTION_CHANGES_GET_REQUESTED',
	SURVEY_QUESTION_CHANGES_GET_SUCCEEDED = 'SURVEY_QUESTION_CHANGES_GET_SUCCEEDED',
	SURVEY_QUESTION_CHANGES_GET_FAILED = 'SURVEY_QUESTION_CHANGES_GET_FAILED',

	// SURVEY COPY MODAL
	SURVEY_COPY_MODAL_GET_USERS_REQUESTED = 'SURVEY_COPY_MODAL_GET_USERS_REQUESTED',
	SURVEY_COPY_MODAL_GET_USERS_SUCCEEDED = 'SURVEY_COPY_MODAL_GET_USERS_SUCCEEDED',
	SURVEY_COPY_MODAL_GET_USER_COUNT = 'SURVEY_COPY_MODAL_GET_USER_COUNT',
}
